import { render } from "./TextImageLandscape.vue?vue&type=template&id=b1cc0976"
import script from "./TextImageLandscape.vue?vue&type=script&lang=js"
export * from "./TextImageLandscape.vue?vue&type=script&lang=js"

import "./TextImageLandscape.vue?vue&type=style&index=0&id=b1cc0976&lang=scss"
script.render = render

export default script